import * as React from 'react';
import { connect } from 'react-redux';
import { AudienceDetailsBasic } from '../../components/audience/AudienceDetailsBasic';
import { AudienceMode } from '../../components/audiences/AudienceMode';
import { ActionCreators } from '../../store/AudienceDetailsStore';
import { ActionCreators as EmailActionCreators } from '../../store/EmailStore';
import * as EmailTemplateActionCreators from '../../store/EmailTemplateSlice';
import { NavigationActions } from '../../store/NavigationActions';
import { IApplicationState } from '../../store/index';
import { AudiencePageStateSetter } from '../state-setter/AudiencePageStateSetter';
import { AudiencePageStateSetterRouteProps } from '../state-setter/AudiencePageStateSetterBase';

export const AudienceDetailsBasicContainer = connect(
	(state: IApplicationState) => ({ ...state.audienceDetails, ...state.emailTemplates, ...state.surveyBuilder }),
	{ ...ActionCreators, ...NavigationActions, ...EmailActionCreators, ...EmailTemplateActionCreators },
)(AudienceDetailsBasic as any) as any;

export class AudienceDetailsBasicPage extends React.PureComponent<AudiencePageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<AudienceDetailsBasicContainer {...this.props} mode={AudienceMode.Edit} />
				<AudiencePageStateSetter {...this.props} />
			</>
		);
	}
}
